import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-event-icon',
  templateUrl: './event-icon.component.html',
  styleUrls: ['./event-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EventIconComponent implements OnInit {
  @Input() eventType: EventType;
  constructor() {}

  ngOnInit(): void {}
}

type EventType =
  | 'Culinair'
  | 'Other'
  | 'Bussines'
  | 'Kunst & Cultuur'
  | 'Markten & Fairs'
  | 'Muziek & Theater'
  | 'Natuur'
  | 'Sport & Actief'
  | 'Sport & actief'
  | 'Festivals'
  | 'Voor kinderen'
  | 'Informatief & Netwerk';
